import api from './api';

const artifactVersionService = {
  /**
   * Get version history for a conversation's artifact
   */
  getVersionHistory: async (conversationId, { limit = 20, offset = 0 } = {}) => {
    const response = await api.get(
      `/conversations/${conversationId}/artifact/versions`,
      { params: { limit, offset } }
    );
    return response.data;
  },

  /**
   * Get full version content by version number
   */
  getVersion: async (conversationId, versionNumber) => {
    const response = await api.get(
      `/conversations/${conversationId}/artifact/versions/${versionNumber}`
    );
    return response.data;
  },

  /**
   * Get section-level diff between two versions
   */
  getDiff: async (conversationId, fromVersion, toVersion) => {
    const response = await api.get(
      `/conversations/${conversationId}/artifact/diff`,
      { params: { from_version: fromVersion, to_version: toVersion } }
    );
    return response.data;
  },
};

export default artifactVersionService;
